import { LitElement, html, Splide } from './-global.min.js'

export class HHAnnouncementBar extends LitElement {
  static properties = {
    slider: { state: true },
    size: {
      type: Number
    },
    interval: {
      type: Number
    }
  }

  connectedCallback() {
    super.connectedCallback()

    const slider = this.querySelector('.splide')
    if (slider) {
      this.initSlider(slider)
    }
  }

  initSlider(slider) {
    this.slider = new Splide(slider, {
      type: 'fade',
      arrows: true,
      pagination: false,
      autoplay: this.size > 1 ? true: false,
      useScroll: true,
      interval: this.interval,
      rewind: true,
      speed: 1000
    })
    this.slider.mount()
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-announcement-bar', HHAnnouncementBar)
